/* eslint-disable unicorn/filename-case -- TODO rename later */
import { queryOptions } from "@tanstack/react-query";

import clientSDK from "~/api/clientSDK";
import { userQueryKeys } from "~/api/user/userQueryKeys";
import { userToInternalUser } from "~/api/user/userToInternalUser";
import { DEFAULT_CACHE_TIME } from "~/constants";

export const userQueryOptions = {
  all: () =>
    queryOptions({
      queryKey: userQueryKeys.all,
      queryFn: () =>
        clientSDK.listUsers("active", "human").catch((err: Error) => {
          throw new Error("An error occurred while loading user list ", err);
        }),
      staleTime: DEFAULT_CACHE_TIME,
      refetchOnWindowFocus: false,
    }),
  byId: (id: string) =>
    queryOptions({
      queryKey: userQueryKeys.byId(id),
      queryFn: () => clientSDK.getUserById(id),
      select: userToInternalUser,
      staleTime: DEFAULT_CACHE_TIME,
    }),
};
